import {Observable} from 'rxjs';

import Track     from '../../../State/Stores/Captions/Track';
import ISolution from '../Interfaces/ISolution';

const subscribeToActiveTrack = (
    activeTrack$: Observable<Track>,
    solution: ISolution
) =>
    activeTrack$
        .subscribe((track: Track) => {
            try {
                solution.setActiveTextTrack(track ? track.index : -1);
            } catch (err) { /** */ }
        });

export default subscribeToActiveTrack;